import React from 'react';
import Layout from '../components/Layout';

function NotFound() {
  return (
   
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>404</h1>
      <p>Page Not Found</p>
    </div>
    
  );
}

export default NotFound;
